import React from 'react';
import { PanelMode } from './call-card.types';
import { CallTimerDisplay } from './CallTimerDisplay';
import { CallControlGrid } from './CallControlGrid';

interface CallActiveControlsProps {
  isMuted: boolean;
  isOnHold: boolean;
  isLoading: string | null;
  isAgentLegActive: boolean;
  panelMode: PanelMode;
  isPanelOpen: boolean;
  formattedDuration: string;
  onMute: () => void;
  onHold: () => void;
  onResume: () => void;
  onEnd: () => void;
  onTransferClick: () => void;
  onConferenceClick: () => void;
}

export function CallActiveControls(props: CallActiveControlsProps) {
  return (
    <>
      <CallTimerDisplay formattedDuration={props.formattedDuration} />
      <CallControlGrid
        isMuted={props.isMuted}
        isOnHold={props.isOnHold}
        isLoading={props.isLoading}
        isAgentLegActive={props.isAgentLegActive}
        panelMode={props.panelMode}
        isPanelOpen={props.isPanelOpen}
        onMute={props.onMute}
        onHold={props.onHold}
        onResume={props.onResume}
        onEnd={props.onEnd}
        onTransferClick={props.onTransferClick}
        onConferenceClick={props.onConferenceClick}
      />
    </>
  );
}

export default CallActiveControls;
